import React from 'react'

const Mcrsft14 = () => {
    return (
        <div className='container'>
                 <h1 class="title">k largest(or smallest) elements in an array | added Min Heap method</h1>
            <p><strong>Question: </strong>Write an efficient program for printing k largest elements in an array. Elements in array can be in any order.<br/>
            For example, if given array is [1, 23, 12, 9, 30, 2, 50] and you are asked for the largest 3 elements i.e., k = 3 then your program should print 50, 30, and 23.</p>
            <p className='output'><strong>Method 1 (Use Bubble k times)</strong>&nbsp;<br/>
            Thanks to Shailendra for suggesting this approach.&nbsp;<br/>
            1) Modify Bubble Sort to run the outer loop at most k times.&nbsp;<br/>
            2) Print the last k elements of the array obtained in step 1.<br/>
            Time Complexity: O(n*k)&nbsp;</p>
            <p>Like Bubble sort, other sorting algorithms like Selection Sort can also be modified to get the k largest elements.</p>
            <p className='output'><strong>Method 2 (Use temporary array)</strong>&nbsp;<br/>
            K largest elements from arr[0..n-1]</p>
            <p>1) Store the first k elements in a temporary array temp[0..k-1].&nbsp;<br/>
            2) Find the smallest element in temp[], let the smallest element be <i>min</i>.&nbsp;<br/>
            3-a) For each element <i>x</i> in arr[k] to arr[n-1]. <strong>O(n-k)</strong>&nbsp;<br/>
            If <i>x </i>is greater than the min then remove <i>min </i>from temp[] and insert <i>x</i>.&nbsp;<br/>
            3-b)Then, determine the new <i>min</i> from temp[]. <strong>O(k)</strong>&nbsp;<br/>
            4) Print final k elements of <i>temp[]</i></p>
            <p>Time Complexity: O((n-k)*k). If we want the output sorted then O((n-k)*k + k*log(k))<br/>
            Thanks to nesamani1822 for suggesting this method.&nbsp;</p>
            <p className='output'><strong>Method 3(Use Sorting)</strong>&nbsp;<br/>
            1) Sort the elements in descending order in O(n*log(n))&nbsp;<br/>
            2) Print the first k numbers of the sorted array O(k).&nbsp;</p>

 <div class="tabs">
    <input type="radio" name="tab" id="tab1" />
    <label for="tab1">CPP</label>
    <input type="radio" name="tab" id="tab2"/>
    <label for="tab2">Java </label>
    <input type="radio" name="tab" id="tab3"/>
    <label for="tab3">Python</label>

  
    <div class="tab-content-wrapper">
      <div id="tab-content-1" class="tab-content">
        <div class="container">
        <div class="container">
    <div class="line number1 index0 alt2"><code class="comment">// C++ code for k largest elements in an array</code>
    </div>
    <div class="line number2 index1 alt1"><code class="library">#include &lt;bits/stdc++.h&gt;</code></div>
    <div class="line number3 index2 alt2"><code class="library">using</code> <code
            class="library">namespace</code> <code class="plain">std;</code></div>
    <div class="line number4 index3 alt1">&nbsp;</div>
    <div class="line number5 index4 alt2"><code class="library">void</code> <code
            class="plain">kLargest(</code><code class="keyword">int</code> <code class="plain">arr[], </code><code
            class="keyword">int</code> <code class="plain">n, </code><code class="keyword">int</code> <code
            class="plain">k)</code></div>
    <div class="line number6 index5 alt1"><code class="plain">&#123;</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// Sort the given array arr in reverse</code></div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// order.</code></div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">sort(arr, arr + n, greater&lt;</code><code class="keyword">int</code><code
            class="plain">&gt;());</code></div>
    <div class="line number10 index9 alt1">&nbsp;</div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// Print the first kth largest elements</code></div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="library">for</code> <code class="plain">(</code><code class="keyword">int</code> <code
            class="plain">i = 0; i &lt; k; i++)</code></div>
    <div class="line number13 index12 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; arr[i] &lt;&lt; </code><code class="string">" "</code><code
            class="plain">;</code></div>
    <div class="line number14 index13 alt1"><code class="plain">&#125;</code></div>
    <div class="line number15 index14 alt2">&nbsp;</div>
    <div class="line number16 index15 alt1"><code class="comment">// driver program</code></div>
    <div class="line number17 index16 alt2"><code class="keyword">int</code> <code class="plain">main()</code></div>
    <div class="line number18 index17 alt1"><code class="plain">&#123;</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">arr[] = &#123; 1, 23, 12, 9, 30, 2, 50 &#125;;</code></div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">n = </code><code class="library">sizeof</code><code
            class="plain">(arr) / </code><code class="library">sizeof</code><code class="plain">(arr[0]);</code>
    </div>
    <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">k = 3;</code></div>
    <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">kLargest(arr, n, k);</code></div>
    <div class="line number23 index22 alt2"><code class="plain">&#125;</code></div>
    <div class="line number24 index23 alt1">&nbsp;</div>
    </div>
  </div>
     </div>
      <div id="tab-content-2" class="tab-content">
        
      <div class="container">
    <div class="line number1 index0 alt2"><code class="comment">// Java code for k largest elements in an array</code>
    </div>
    <div class="line number2 index1 alt1"><code class="keywords">import</code> <code
            class="plain">java.util.Arrays;</code></div>
    <div class="line number3 index2 alt2"><code class="keywords">import</code> <code
            class="plain">java.util.Collections;</code></div>
    <div class="line number4 index3 alt1"><code class="keywords">import</code> <code
            class="plain">java.util.ArrayList;</code></div>
    <div class="line number5 index4 alt2">&nbsp;</div>
    <div class="line number6 index5 alt1"><code class="keywords">class</code> <code class="plain">NooB &#123;</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">public</code> <code class="keywords">static</code> <code class="keywords">void</code> <code
            class="plain">kLargest(Integer[] arr, </code><code class="keywords">int</code> <code class="plain">k)</code>
    </div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number9 index8 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// Sort the given array arr in reverse order</code></div>
    <div class="line number10 index9 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// This method doesn't work with primitive data</code></div>
    <div class="line number11 index10 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// types. So, instead of int, Integer type</code></div>
    <div class="line number12 index11 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// array will be used</code></div>
    <div class="line number13 index12 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Arrays.sort(arr, Collections.reverseOrder());</code></div>
    <div class="line number14 index13 alt1">&nbsp;</div>
    <div class="line number15 index14 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// Print the first kth largest elements</code></div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">for</code> <code class="plain">(</code><code class="keywords">int</code> <code
            class="plain">i = </code><code class="value">0</code><code class="plain">; i &lt; k; i++)</code></div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.print(arr[i] + </code><code class="string">" "</code><code class="plain">);</code>
    </div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
   
    <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="keywords">public</code> <code class="keywords">static</code> <code
            class="plain">ArrayList&lt;Integer&gt; kLargest(</code><code class="keywords">int</code><code
            class="plain">[] arr, </code><code class="keywords">int</code> <code class="plain">k)</code></div>
    <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">//Convert using stream</code></div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Integer[] obj_array = Arrays.stream( arr ).boxed().toArray( Integer[] :: </code><code
            class="keywords">new</code><code class="plain">);</code></div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Arrays.sort(obj_array, Collections.reverseOrder());</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">ArrayList&lt;Integer&gt; list = </code><code class="keywords">new</code> <code
            class="plain">ArrayList&lt;&gt;(k);</code></div>
    <div class="line number27 index26 alt2">&nbsp;</div>
    <div class="line number28 index27 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">for</code> <code class="plain">(</code><code class="keywords">int</code> <code
            class="plain">i = </code><code class="value">0</code><code class="plain">; i &lt; k; i++)</code></div>
    <div class="line number29 index28 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">list.add(obj_array[i]);</code></div>
    <div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number31 index30 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">return</code> <code class="plain">list;</code></div>
    <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number33 index32 alt2">&nbsp;</div>
    <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">public</code> <code class="keywords">static</code> <code class="keywords">void</code> <code
            class="plain">main(String[] args)</code></div>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number36 index35 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Integer arr[] = </code><code class="keywords">new</code> <code
            class="plain">Integer[] &#123; </code><code class="value">1</code><code class="plain">, </code><code
            class="value">23</code><code class="plain">, </code><code class="value">12</code><code
            class="plain">, </code><code class="value">9</code><code class="plain">,</code></div>
    <div class="line number37 index36 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="value">30</code><code class="plain">, </code><code class="value">2</code><code
            class="plain">, </code><code class="value">50</code> <code class="plain">&#125;;</code></div>
    <div class="line number38 index37 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">int</code> <code class="plain">k = </code><code class="value">3</code><code
            class="plain">;</code></div>
    <div class="line number39 index38 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">kLargest(arr, k);</code></div>
    <div class="line number40 index39 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number41 index40 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">//This code is contributed by Niraj Dubey</code></div>
    <div class="line number42 index41 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">//What if primitive datatype array is passed and wanted to return in ArrayList&lt;Integer&gt;</code>
    </div>
    <div class="line number43 index42 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">int</code><code class="plain">[] prim_array = &#123; </code><code class="value">1</code><code
            class="plain">, </code><code class="value">23</code><code class="plain">, </code><code
            class="value">12</code><code class="plain">, </code><code class="value">9</code><code
            class="plain">, </code><code class="value">30</code><code class="plain">, </code><code
            class="value">2</code><code class="plain">, </code><code class="value">50</code> <code
            class="plain">&#125;;</code></div>
    <div class="line number44 index43 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.print(kLargest(prim_array, k));</code></div>
    <div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number46 index45 alt1"><code class="plain">&#125;</code></div>
  
</div> </div>
      <div id="tab-content-3" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code
            class="comment">''' Python3 code for k largest elements in an array'''</code></div>
    <div class="line number2 index1 alt1">&nbsp;</div>
    <div class="line number3 index2 alt2"><code class="keywords">def</code> <code class="plain">kLargest(arr, k):</code>
    </div>
    <div class="line number4 index3 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment"># Sort the given array arr in reverse</code></div>
    <div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment"># order.</code></div>
    <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">arr.sort(reverse </code><code class="keywords">=</code> <code class="color1">True</code><code
            class="plain">)</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment"># Print the first kth largest elements</code></div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">for</code> <code class="plain">i </code><code class="keywords">in</code> <code
            class="functions">range</code><code class="plain">(k):</code></div>
    <div class="line number9 index8 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">print</code> <code class="plain">(arr[i], end </code><code class="keywords">=</code><code
            class="string">" "</code><code class="plain">)</code></div>
    <div class="line number10 index9 alt1">&nbsp;</div>
    <div class="line number11 index10 alt2"><code class="comment"># Driver program</code></div>
    <div class="line number12 index11 alt1"><code class="plain">arr </code><code class="keywords">=</code> <code
            class="plain">[</code><code class="value">1</code><code class="plain">, </code><code
            class="value">23</code><code class="plain">, </code><code class="value">12</code><code
            class="plain">, </code><code class="value">9</code><code class="plain">, </code><code
            class="value">30</code><code class="plain">, </code><code class="value">2</code><code
            class="plain">, </code><code class="value">50</code><code class="plain">]</code></div>
    <div class="line number13 index12 alt2"><code class="comment"># n = len(arr)</code></div>
    <div class="line number14 index13 alt1"><code class="plain">k </code><code class="keywords">=</code> <code
            class="value">3</code></div>
    <div class="line number15 index14 alt2"><code class="plain">kLargest(arr, k)</code></div>
    <div class="line number16 index15 alt1">&nbsp;</div>
    

        </div> 
   </div>
     </div>
  </div>
  <br /> <br /> <br /> <br /> <br />
        </div>
    )
}

export default Mcrsft14
